import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BannerRotator } from 'cityads-v3/types/bannerRotator';
import { SadukaResponseEntity } from 'cityads-v3/types/saduka';
import { makeRequest } from 'cityads-v3/utils/apiUtils';

export const initialState = {
  isSaving: false,
  isSaved: false,
  lastCreatedRotator: null as BannerRotator
}

export const slice = createSlice({
  name: 'bannerRotator',
  initialState,
  reducers: {
    saveBannerRotator: (state) => {
      state.isSaving = true
      state.isSaved = false
    },
    saveBannerRotatorSuccess: (state, action: PayloadAction<SadukaResponseEntity<'bannerRotator', BannerRotator>>) => {
      state.isSaving = false
      state.isSaved = true
      state.lastCreatedRotator = action.payload.bannerRotator
    },
    saveBannerRotatorFail: (state) => {
      state.isSaving = false
      state.isSaved = false
    },

    removeBannerRotator: () => {},
    removeBannerRotatorSuccess: () => {},
    removeBannerRotatorFail: () => {},
  }
})

const {
  removeBannerRotator,
  removeBannerRotatorSuccess,
  removeBannerRotatorFail,
  saveBannerRotator,
  saveBannerRotatorSuccess,
  saveBannerRotatorFail,
} = slice.actions

/**
 * Создание ротатора баннеров
 */
export function createBannerRotator(data: BannerRotator) {
  return makeRequest(`/saduka/bannerRotators`, {
    types: [
      saveBannerRotator.type,
      saveBannerRotatorSuccess.type,
      saveBannerRotatorFail.type
    ],
    options: {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        bannerRotator: {
          ...data,
          add_new_offer: data.add_new_offer ? 1 : 0,
          enable_optimization: data.enable_optimization ? 1 : 0,
        }
      })
    }
  })
}

export function editBannerRotator(id: number, data: BannerRotator) {
  return makeRequest(`/saduka/bannerRotators/${id}`, {
    types: [
      saveBannerRotator.type,
      saveBannerRotatorSuccess.type,
      saveBannerRotatorFail.type
    ],
    options: {
      credentials: 'include',
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        bannerRotator: {
          ...data,
          add_new_offer: data.add_new_offer ? 1 : 0,
          enable_optimization: data.enable_optimization ? 1 : 0,
        }
      })
    }
  })
}

export function deleteBannerRotator(id: BannerRotator['id']) {
  return makeRequest(`/saduka/bannerRotators/${id}`, {
    types: [
      removeBannerRotator.type,
      removeBannerRotatorSuccess.type,
      removeBannerRotatorFail.type
    ],
    options: {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
    }
  })
}

export default slice.reducer;
